import axios from 'axios';

import { getData } from '@feature/utils';

import {
  UserDocument,
  UserDocumentAdminPage,
  UserDocumentAdminParams,
  UserDocumentAdminUploadRequest,
  UserDocumentExportParams,
  UserDocumentKind,
  UserDocumentScope,
  UserDocumentSlot,
  UserDocumentSummary,
  UserDocumentUploadRequest,
  UserDocumentsRow,
} from './UserDocumentTypes';

export function getMine() {
  return axios.get<UserDocumentSlot[]>('/user-documents/mine').then(getData);
}

export function upload(request: UserDocumentUploadRequest) {
  const formData = new FormData();
  formData.append('file', request.file);

  return axios
    .put<UserDocument>(`/user-documents/mine/${request.kind}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function download(kind: UserDocumentKind) {
  return axios.get<Blob>(`/user-documents/mine/${kind}/download`, { responseType: 'blob' });
}

export function deleteByKind(kind: UserDocumentKind) {
  return axios.delete<unknown>(`/user-documents/mine/${kind}`).then(getData);
}

export function getUsersPaged(params: UserDocumentAdminParams) {
  return axios
    .get<UserDocumentAdminPage>('/user-documents/users/paged', {
      params,
    })
    .then(getData);
}

export function getUser(userId: number) {
  return axios.get<UserDocumentsRow>(`/user-documents/users/${userId}`).then(getData);
}

export function getSummary(params: UserDocumentScope) {
  return axios
    .get<UserDocumentSummary>('/user-documents/summary', {
      params,
    })
    .then(getData);
}

export function uploadFor(request: UserDocumentAdminUploadRequest) {
  const formData = new FormData();
  formData.append('file', request.file);

  return axios
    .put<UserDocument>(`/user-documents/users/${request.userId}/${request.kind}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function downloadFor(userId: number, kind: UserDocumentKind) {
  return axios.get<Blob>(`/user-documents/users/${userId}/${kind}/download`, { responseType: 'blob' });
}

export function deleteFor(userId: number, kind: UserDocumentKind) {
  return axios.delete<unknown>(`/user-documents/users/${userId}/${kind}`).then(getData);
}

export function downloadArchive(params: UserDocumentScope) {
  return axios.get<Blob>('/user-documents/archive', { responseType: 'blob', params });
}

export function downloadExport(params: UserDocumentExportParams) {
  return axios.get<Blob>('/user-documents/export', { responseType: 'blob', params });
}
